"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountDetailService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
const http_1 = require("@angular/common/http");
class AccountDetailService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.accountDetailUrl = '/rest-api/profile/v1/get/personalInfo';
        this.validatePersonalInfoUrl = '/rest-api/profile/v1/edit/personalInfo';
        this.contactInformationUrl = '/rest-api/profile/v1/get/accountInfo';
        this.validateSecurityUrl = '/rest-api/profile/v2/edit/accountInfo';
        this.updateUserIdUrl = '/rest-api/profile/v1/edit/userId';
        this.preferenceCenterUrl = '/rest-api/profile/v1/getPreferences';
        this.specialPromotionUrl = '/rest-api/profile/v1/get/specialPromotions';
        this.validatePromotionUrl = '/rest-api/profile/v1/edit/specialPromotions';
        this.paymentMethodUrl = '/rest-api/profile/v1/get/primaryPayMethods';
        this.paymentEditUrl = '/rest-api/profile/v1/edit/paymentMethod';
        this.homeServicePersonalInfoUrl = '/rest-api/fiber/account/profile/v1/get/personalInfo';
        this.validateHSPersonalInfoUrl = '/rest-api/fiber/account/profile/v1/edit/personalInformation';
        this.validateSecondaryUrl = '/rest-api/profile/v1/edit/secondaryToPrimary';
        this.allStateListUrl = '/rest-api/misc/v1/states?allStates=true';
        this.companyInformationUrl = '/rest-api/profile/v1/companyInfo';
        this.companyInfoEditUrl = '/rest-api/profile/v1/business/companyInfo';
        this.accountHodlerEditUrl = '/rest-api/profile/v1/accountInfo/business';
        this.equipmentAccountUrl = '/rest-api/account/v1/equipment/accountDetails';
        this.linkAccountUrl = '/rest-api/account/v1/submit/equipmentAccountId';
        this.paymentOauthTokenUrl = '/rest-api/payment/oauth/v1/accessToken';
        this.errorMsgUrl = '/resources/json/mma/tokenserviceerrormessage.json';
        this.submitPreferencesUrl = '/rest-api/profile/v1/preferences/update';
        this.getPreferencesUrl = '/rest-api/profile/v1/getPreferences';
        this.accountAccessPermissionUrl = '/rest-api/account/user-management/v1/access';
        this.getRolesUrl = '/rest-api/account/user-management/v1/access/roles';
        this.getCommunicationPreferenceUrl = '/rest-api/fiber/account/profile/v1/communication-info';
        this.updateCommunicationPreferenceUrl = '/rest-api/fiber/account/profile/v1/preference';
        this.addRemoveFeaturesUrl = '/rest-api/order/v1/addRemoveFeatures';
    }
    getPersonalInformation() {
        return this.get(this.accountDetailUrl).pipe(operators_1.map((data) => data));
    }
    validatePersonalInformation(value) {
        const inputArgs = new http_1.HttpParams().set('addressLine1', value.addressLine1)
            .set('addressLine2', value.addressLine2).set('city', value.city)
            .set('state', value.state).set('zip', value.zip)
            .set('email', value.email);
        return this.post(this.validatePersonalInfoUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getAccountContactInformation() {
        return this.get(this.contactInformationUrl).pipe(operators_1.map((data) => data));
    }
    getAllStatesList() {
        return this.get(this.allStateListUrl).pipe(operators_1.map((data) => data));
    }
    validateContactInformation(value, isPrepaidAcc, isBusiness, isUpdateAccountInfoAllowed) {
        if (!isBusiness || (isBusiness && !isUpdateAccountInfoAllowed)) {
            const accountPin = value.accountPin ? encodeURIComponent(value.accountPin) : '';
            const selected_mobile_no = (typeof value.selected_mobile_no === 'undefined') ? '' : value.selected_mobile_no;
            const password = value.password ? encodeURIComponent(value.password) : '';
            const confirmPassword = value.confirmPassword ? encodeURIComponent(value.confirmPassword) : '';
            const inputArgs = new http_1.HttpParams().set('password', password).set('confirmPassword', confirmPassword)
                .set('selected_mobile_no', selected_mobile_no).set('accountPin', accountPin);
            return this.post(this.validateSecurityUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
            // ToDo :need to discuss about above post request, to be changed to put?
        }
        else {
            return this.put(this.accountHodlerEditUrl, value, true).pipe(operators_1.map((data) => data));
        }
    }
    submitPaymentInfo(value) {
        const inputArgs = new http_1.HttpParams().set('paymentType', value.paymentType)
            .set('defaultMMAPaymentType', value.defaultMMAPaymentType).set('routingNumber', value.routingNumber)
            .set('routingNumberConfirm', value.routingNumberConfirm).set('accountNumber', value.accountNumber)
            .set('accountNumberConfirm', value.accountNumberConfirm).set('lastFourSSN', value.lastFourSSN)
            .set('firstName', value.firstName).set('lastName', value.lastName)
            .set('cardNumber', value.cardNumber).set('cardExpirationMonth', value.cardExpirationMonth)
            .set('cardExpirationYear', value.cardExpirationYear).set('cvv', value.cvv)
            .set('addressLine1', value.addressLine1).set('addressLine2', value.addressLine2)
            .set('city', value.city).set('state', value.state).set('zipCode', value.zipCode).set('defaultCard', value.defaultCard).set('kHash', value.kHash)
            .set('creditCardType', value.creditCardType);
        return this.post(this.paymentEditUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getPreferenceCenterInformation() {
        return this.get(this.preferenceCenterUrl).pipe(operators_1.map((data) => data));
    }
    getPaymentMethodInformation() {
        return this.get(this.paymentMethodUrl).pipe(operators_1.map((data) => data));
    }
    submitUserIdInfo(value) {
        const inputArgs = new http_1.HttpParams().set('login', value.login).set('confirmLogin', value.confirmLogin);
        return this.post(this.updateUserIdUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getSpecialPromotions() {
        return this.get(this.specialPromotionUrl).pipe(operators_1.map((data) => data));
    }
    validateSpecialPromotions(value) {
        const inputArgs = new http_1.HttpParams().set('promotionalTopics', value);
        return this.post(this.validatePromotionUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    validateSecondaryToPrimary(value) {
        const inputArgs = new http_1.HttpParams().set('ssn', value.ssn);
        return this.post(this.validateSecondaryUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getHomeServicePersonalInformation() {
        return this.get(this.homeServicePersonalInfoUrl).pipe(operators_1.map((data) => data));
    }
    getCommunicationPreference() {
        return this.get(this.getCommunicationPreferenceUrl).pipe(operators_1.map((data) => data));
    }
    updateCommunicationPreference(value) {
        const inputArgs = new http_1.HttpParams().set('communicationPreference', value);
        return this.put(this.updateCommunicationPreferenceUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    validateHomeServicePersonalInfo(value) {
        const inputArgs = new http_1.HttpParams().set('addressLine1', value.addressLine1)
            .set('addressLine2', (value.addressLine2 ? value.addressLine2 : '')).set('city', value.city).set('state', value.state).set('postalCode', value.zip)
            .set('emailAddress', value.email).set('phone', value.mobileNumber);
        return this.post(this.validateHSPersonalInfoUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getCompanyInformation() {
        return this.get(this.companyInformationUrl).pipe(operators_1.map((data) => data));
    }
    validateCompanyInformation(content) {
        return this.put(this.companyInfoEditUrl, content, true).pipe(operators_1.map((data) => data));
    }
    getEquipmentAccountDetails() {
        return this.get(this.equipmentAccountUrl).pipe(operators_1.map((data) => data));
    }
    linkAccount(value) {
        const inputArgs = new http_1.HttpParams().set('selectedEquipAccId', value);
        return this.post(this.linkAccountUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getOauthAccessToken() {
        return this.get(this.paymentOauthTokenUrl).pipe(operators_1.map((data) => data));
    }
    // Payment Token Service
    getPaymentToken(content, header, paymentUrl) {
        return this.post(paymentUrl, content, true, header).pipe(operators_1.map((data) => data));
    }
    getCSErrorMessage() {
        return this.get(this.errorMsgUrl).pipe(operators_1.map((data) => data));
    }
    // Submit Preferences
    submitIndividualPreferences(subscription, postEmail, postText) {
        const inputArgs = new http_1.HttpParams().set('subId', subscription)
            .set('prefEmail', postEmail)
            .set('prefText', postText)
            .set('applyEmailToAll', 'false')
            .set('applyTextToAll', 'false');
        return this.post(this.submitPreferencesUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    // Submit All Preferences
    submitAllEmailsPreferences(postEmail) {
        const inputArgs = new http_1.HttpParams().set('subId', '')
            .set('prefEmail', postEmail)
            .set('applyEmailToAll', 'true');
        return this.post(this.submitPreferencesUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    submitAllTextsPreferences(postText) {
        const inputArgs = new http_1.HttpParams().set('subId', '')
            .set('prefText', postText)
            .set('applyTextToAll', 'true');
        return this.post(this.submitPreferencesUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    // Get Preferences
    getPreferences() {
        return this.get(this.getPreferencesUrl).pipe(operators_1.map((data) => data));
    }
    getAccountAccessPermission() {
        if (this.accountAccessObservable) {
            return this.accountAccessObservable;
        }
        else {
            this.accountAccessObservable = this.get(this.accountAccessPermissionUrl).pipe(operators_1.map((data) => {
                this.accountAccessObservable = null;
                return data;
            }), operators_1.share());
            return this.accountAccessObservable;
        }
    }
    removeAccountAccessPermission(roleDetails) {
        return this.deleteJsonApplicationData(this.accountAccessPermissionUrl, roleDetails, true).pipe(operators_1.map((data) => data));
    }
    updateAuthorizedUser(roleDetails) {
        return this.put(this.accountAccessPermissionUrl, roleDetails, true).pipe(operators_1.map((data) => data));
    }
    createAuthorizedUser(roleDetails) {
        return this.post(this.accountAccessPermissionUrl, roleDetails, true).pipe(operators_1.map((data) => data));
    }
    getRolesAndResponsibilities() {
        return this.get(this.getRolesUrl).pipe(operators_1.map((data) => data));
    }
    addRemoveFeatures(content) {
        return this.post(this.addRemoveFeaturesUrl, content, true).pipe(operators_1.map((data) => data));
    }
}
exports.AccountDetailService = AccountDetailService;
//# sourceMappingURL=accountsettings.service.js.map